import React, { Fragment } from "react";
import { Col } from "react-bootstrap";

import piscinaChica from "../../assets/PiscinaChica.png";

const RazonCuatro = () => {
  return (
    <Fragment>
      <Col
        lg={6}
        className="contentCards cardLigth "
        id="razonCuantro"
        data-aos="zoom-in"
        data-aos-offset="300"
        data-aos-duration="1000"
        data-aos-easing="ease-out"
      >
        <h4>Razón #4</h4>
        <h2 data-aos="fade-right" data-aos-offset="300" data-aos-duration="500">
          Evolución
        </h2>
        <p data-aos="fade-right" data-aos-offset="300" data-aos-duration="500">
          Somos tendencia, somos las únicas piscinas que cuentan con su tercer
          evolución en su diseño.
        </p>
        <div className="contentPiletas">
          <img
            src={piscinaChica}
            className="piscinaChica"
            data-aos="fade-up"
            alt="Somos tendencia"
            data-aos-offset="200"
            data-aos-duration="1000"
            data-aos-easing="ease-out"
          ></img>
          <img
            src={piscinaChica}
            className="piscinaMediana"
            data-aos="fade-up"
            alt="Somos tendencia"
            data-aos-offset="240"
            data-aos-duration="1000"
            data-aos-easing="ease-out"
          ></img>
          <img
            src={piscinaChica}
            className="piscinaGrande"
            data-aos="fade-up"
            alt="Somos tendencia"
            data-aos-offset="280"
            data-aos-duration="1000"
            data-aos-easing="ease-out"
          ></img>
        </div>
      </Col>
    </Fragment>
  );
};

export default RazonCuatro;
